import * as React from 'react';
var TriggerContext = React.createContext(null);
export default TriggerContext;